import env from "../libs/tools/Environment";

export const state = {
  urls: null,
  is_outdated: false,
};
export const mutations = {
  setUrls(state, data) {
    state.urls = data;
  },
  setOutdated(state, data) {
    state.is_outdated = data;
  },
};
export const getters = {
  getUrls(state) {
    return state.urls;
  },
  isOutdated(state) {
    return state.is_outdated;
  },
};
export const actions = {
  getTermsInfo({ commit, getters }, force_run) {
    if (getters.getUrls) return false;
    const api_method = env.isPromoPage() || force_run ? "run" : "batch";
    return window.api.termsService
      .info()
      [api_method]()
      .then(response => {
        if (!response.data.error) {
          commit("setOutdated", response.data.result.is_outdated);
          commit("setUrls", response.data.result.urls);
        }
      });
  },
  acceptTerms({ commit }) {
    return window.api.termsService
      .accept()
      .run()
      .then(response => {
        if (response.data.error) {
          console.error("Terms accept fail");
        }
        commit("setOutdated", false);
      });
  },
};
const store = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
export default store;
